export const verificationRequests = {
  appBarTitle: "طلبات التحقق",
  totalRequests: "إجمالى الطلبات",
  table: {
    requestNumber: "رقم الطلب",
    driverName: "اسم السائق",
    driverNumber: "رقم السائق",
    ownerName: "اسم المالك",
    status: "الحالة",
    numberOfTrips: "عدد الرحلات",
    joiningDate: "تاريخ الانضمام",
    requestDate: "تاريخ الطلب",
    decisionDate: "تاريخ القرار",
    viewRejectionReason: "عرض سبب الرفض",
    rejectionReason: "سبب الرفض",
  },
  filters: {
    joiningDate: "تاريخ الانضمام",
    requestDate: "ناريخ الطلب",
    teamName: "اسم الفريق",
    driverName: "اسم السائق",
    numberOfTrips: "عدد الرحلات",
    decisionDate: "تاريخ القرار",
    status: "الحالة",
  },
  status: {
    pending: "معلق",
    rejected: "مرفوض",
    accepted: "مقبول",
  },
};
